import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormQuestionApiModel, MoveRelatedApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class CustomQuestionsItemService {
  public url = 'form-questions';

  constructor(private readonly http: HttpClientService) {}

  public add(model: FormQuestionApiModel): Observable<FormQuestionApiModel> {
    return this.http.post<FormQuestionApiModel>(`${this.url}/add`, model);
  }

  public update(model: FormQuestionApiModel): Observable<FormQuestionApiModel> {
    return this.http.put<FormQuestionApiModel>(`${this.url}/update`, model);
  }

  public delete(model: FormQuestionApiModel): Observable<void> {
    return this.http.delete<void>(`${this.url}/delete/${model.Id}`);
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return this.http.put<void>(`${this.url}/move`, model);
  }
}
